<template>
  <span class="text-link" @click="onClick" >
    {{text}}
  </span>
</template>

<script>
export default {
  name: 'text-link-inline',
  props: {
    text: { type: String }
  },
  methods: {
    onClick () {
      this.$emit('click-text', this.text)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../unified.scss';
.text-link {
    color:blue;
    margin: 0em;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/TextLinkInline.vue